import Skeleton from '@mui/material/Skeleton';

const TextFieldSkeleton = () => {
  return <Skeleton variant="text" width="100%" height={56} />;
};

export default TextFieldSkeleton;
